import React, { Fragment } from 'react';

import '../../styles/containers/Party.css';
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Form,
} from 'react-bootstrap';
import moment from 'moment';
import { AxiosError } from 'axios';

import SimpleSelect from '../utils/FormWidgets/SimpleSelect';
import DatePicker from '../utils/FormWidgets/DatePicker';
import TimePicker from '../utils/FormWidgets/TimePicker';
import Switcher from '../utils/FormWidgets/Switcher';
import {
  getTimeWithOffset,
  getDateInUTC,
  getMilisecondsFromUTCTime,
} from '../../infrastructure/utils/common';
import NumericInput from '../utils/FormWidgets/NumericInput';
import { EDT } from '../../infrastructure/constants/common';
import Rq from '../utils/FormWidgets/RequireField';

class Promo {
  name = '';
  startDate = undefined;
  endDate = undefined;
  type = '$';
  value:number|string = '';
  start = 0;
  end = 0;
  status = 'active';
  category:string = 'regular'
}

class State {
  promo = new Promo();
  isSuccsess = false;
  isError = false;
  percent = false;
  errorText = '';
  codeError = false;
  openModal = false;
  valueError = false;
  startDateError = false;
  endDateError = false;
  value = '';
  timeError = false;
  isNewPromo = true;
  isDeactive = false;
  start = 0;
  end = 0;
  selectedType: string | undefined;
  selectedValue: string | number | undefined;
}

interface PromoFormProps {
  promo: Promo;
  handleCreatePromoSubmit: (sendPromo: Promo, addElse: boolean) => void;
  handleUpdatePromoSubmit: (sendPromo: Promo) => void;
  isError: boolean;
  succsess: (text: string) => void;
  error: (text: string) => void;
}

export class PromoForm extends React.Component<PromoFormProps,State> {
  state = new State();

  componentDidMount() {
    let { promo } = this.props;
    if (promo !== undefined) {
      if (promo.startDate !== '' && promo.startDate !== undefined) {
        this.setState({
          start: getMilisecondsFromUTCTime(
            moment(promo.startDate).tz(EDT).hour(),
            moment(promo.startDate).tz(EDT).minute()
          ),
          end: getMilisecondsFromUTCTime(
            moment(promo.endDate).tz(EDT).hour(),
            moment(promo.endDate).tz(EDT).minute()
          ),
          selectedType: promo.type,
          selectedValue: promo.value
        });
        promo = {
          ...promo,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          startDate: getTimeWithOffset(promo.startDate),
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          endDate: getTimeWithOffset(promo.endDate),
        };
      }
      this.setState({
        promo,
        percent: promo.type === '%',
        isNewPromo: false,
      });
    } else {
      this.setState({ promo: new Promo() });
    }
  }

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  handleChange = ({ target }) => {
    this.setState(prevState => {
      const promo = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.promo,
        [target.id]: target.value,
      };
      return { promo };
    });
  };

  handleTypeChange = value => {
    // @ts-ignore
    this.setState(prevState => {
      const promo = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.promo,
        type: value,
      };
      const persent = value === '%';
      return { promo, persent };
    });
  };
  handleCategoryChange = value => {
    this.setState(prevState => {
      const isFreebie = value === 'freebie';
      const promo:Promo = {
        ...prevState.promo,
        category: value,
      };

      if(isFreebie){
        promo.type = '%';
        promo.value = 100;
      } else {
        if (prevState.promo?.category === 'freebie') {
          promo.type = prevState.selectedType || prevState.promo?.type;
          promo.value = prevState.selectedValue || prevState.promo?.value;
        }
      }

      return {
        promo,
        selectedType: isFreebie ? prevState.promo.type : undefined,
        selectedValue: isFreebie ? prevState.promo.value : undefined,
        percent: promo.type === '%'
      };
    });
  };
  handleCurrencyChange = ({ target }) => {
    if (target.validity.valid) {
      // @ts-ignore
      this.setState(prevState => {
        const promo = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevState.promo,
          value: target.value !== null ? Number.parseFloat(target.value) : 0.0,
        };
        return { promo };
      });
    }
  };

  handleStartDateChange = value => {
    this.setState(prevState => {
      const promo = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.promo,
        startDate: value,
      };
      return { promo };
    });
  };

  handleEndDateChange = value => {
    this.setState(prevState => {
      const promo = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.promo,
        endDate: value,
      };
      return { promo };
    });
  };

  handleStartTimeChange = value => {
    this.setState({ start: value });
  };

  handleEndTimeChange = value => {
    this.setState({ end: value });
  };

  handleSubmit = async (e, addElse = false) => {
    if (this.validateForm()) {
      const {
        handleCreatePromoSubmit,
        handleUpdatePromoSubmit,
        succsess,
        error,
      } = this.props;
      const { promo, isNewPromo } = this.state;
      let sendPromo = promo;
      if (promo.startDate !== undefined && promo.startDate !== '') {
        const { start, end } = this.state;
        sendPromo = {
          ...promo,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          startDate: `${getDateInUTC(
            sendPromo.startDate,
            start
          ).toISOString()}`,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          endDate: `${getDateInUTC(sendPromo.endDate, end).toISOString()}`,
        };
      }
      try {
        if (isNewPromo) {
          await handleCreatePromoSubmit(sendPromo, addElse);
          succsess('Promo code created');
          if (addElse) {
            this.setState({ promo: new Promo() });
          }
        } else {
          await handleUpdatePromoSubmit(sendPromo);
          succsess('Promo code updated');
        }
      } catch (e) {
        const err = e as AxiosError;
        if (err?.response?.data.message === 'The conditional request failed') {
          error('This code already exist');
        } else {
          error(
            `Error code: ${err?.response?.status} \nError message: ${err?.response?.data}`
          );
        }
      }
    }
  };

  createAndAddElse = () => {
    this.handleSubmit(null, true);
  };

  changePromoStatus = async () => {
    const { handleUpdatePromoSubmit, error } = this.props;
    let { promo } = this.state;
    promo = {
      ...promo,
      status: promo.status === 'active' ? 'inactive' : 'active',
    };
    let sendPromo = promo;
    if (sendPromo.startDate !== undefined && sendPromo.startDate !== '') {
      const { start, end } = this.state;
      sendPromo = {
        ...sendPromo,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        startDate: `${getDateInUTC(sendPromo.startDate, start).toISOString()}`,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        endDate: `${getDateInUTC(sendPromo.endDate, end).toISOString()}`,
      };
    }
    this.setState({ promo });
    try {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      await handleUpdatePromoSubmit(sendPromo, false);
    } catch (e) {
      const err = e as AxiosError;
      error(
        `Error code: ${err?.response?.status} \nError message: ${err?.response?.data}`
      );
    }
  };

  validateForm() {
    let startDateError = false;
    let endDateError = false;
    const { promo, percent, start, end } = this.state;
    const reg = /^[A-Z0-9]{1,10}$/;
    reg.lastIndex = 0;
    const codeError = !reg.test(promo.name);
    let timeError = false;
    const valueError = percent
      ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        promo.value <= 0 || promo.value > 100
      : // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        promo.value <= 0;
    const emptyStartDate =
      promo.startDate === '' || promo.startDate === undefined;
    const emptyEndDate = promo.endDate === '' || promo.endDate === undefined;
    if (!(emptyStartDate && emptyEndDate)) {
      startDateError = emptyStartDate;
      endDateError = emptyEndDate;
      if (!emptyStartDate && !emptyEndDate) {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const valid = promo.startDate <= promo.endDate;
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        if (promo.startDate.valueOf() === promo.endDate.valueOf()) {
          timeError = start > end;
        }
        startDateError = !valid;
        endDateError = !valid;
      }
    }

    this.setState({
      codeError,
      valueError,
      startDateError,
      endDateError,
      timeError,
    });
    return !(
      codeError ||
      valueError ||
      startDateError ||
      endDateError ||
      timeError
    );
  }

  render() {
    const {
      promo,
      percent,
      codeError,
      startDateError,
      start,
      end,
      endDateError,
      valueError,
      isNewPromo,
      timeError,
    } = this.state;
    let buttonText = 'Create Promo Code';
    let header = 'Create Promo Code';
    if (!isNewPromo) {
      buttonText = 'Update';
      header = 'Edit Promo Code';
    }
    const active = promo.status === 'active';
    const isFreebie = promo.category === 'freebie';
    return (
      <Fragment>
        <div className='form-content'>
          <h4 className='modal-head'>{header}</h4>
          <Form onSubmit={null}>
            {!isNewPromo && (
              <div>
                <div
                  style={{
                    fontSize: '18px',
                    verticalAlign: 'bottom',
                    display: 'inline-block',
                    paddingBottom: '4px',
                  }}
                >
                  Active code{' '}
                </div>
                {
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  <Switcher
                    onChange={this.changePromoStatus}
                    id='test'
                    style={{
                      paddingTop: '10px',
                      marginLeft: '15px',
                      display: 'inline-block',
                    }}
                    checked={promo.status === 'active'}
                  />
                }
              </div>
            )}
            <FormGroup
              controlId='name'
              validationState={codeError ? 'error' : null}
              className='col-md-12'
              style={{
                paddingLeft: '0px',
                paddingRight: '0px',
                marginTop: '16px',
              }}
            >
              <ControlLabel>
                Code
                <Rq />
              </ControlLabel>
              <FormControl
                type='text'
                disabled={!isNewPromo || !active}
                onChange={this.handleChange}
                value={promo.name}
              />
              <HelpBlock>
                capital letters and numbers only, 10 characters max
              </HelpBlock>
            </FormGroup>
            <div className='row' style={{ marginBottom: '30px' }}>
              <FormGroup controlId='category' className='col-md-4'>
                <ControlLabel>
                  Category
                  <Rq />
                </ControlLabel>
                <SimpleSelect
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={this.handleCategoryChange}
                  value={promo.category}
                  disabled={!active}
                  data={[
                    { value: 'regular', label: 'Regular' },
                    { value: 'promotion', label: 'Promotion' },
                    { value: 'freebie', label: 'Freebie' },
                  ]}
                />
              </FormGroup>
              <FormGroup controlId='type' className='col-md-4'>
                <ControlLabel>
                  Type
                  <Rq />
                </ControlLabel>
                <SimpleSelect
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={this.handleTypeChange}
                  value={promo.type}
                  disabled={!active || isFreebie}
                  data={[
                    { value: '$', label: '$' },
                    { value: '%', label: '%' },
                  ]}
                />
              </FormGroup>
              {!percent && (
                <FormGroup
                  controlId='value'
                  validationState={valueError ? 'error' : null}
                  className='col-md-4'
                >
                  <ControlLabel>
                    Discount Value
                    <Rq />
                  </ControlLabel>
                  {
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    <NumericInput
                      onChange={this.handleCurrencyChange}
                      value={promo.value}
                      type='$'
                      disabled={!active || isFreebie}
                    />
                  }
                </FormGroup>
              )}
              {percent && (
                <FormGroup
                  controlId='value'
                  validationState={valueError ? 'error' : null}
                  className='col-md-4'
                >
                  <ControlLabel>
                    Discount Value
                    <Rq />
                  </ControlLabel>
                  {
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    <NumericInput
                      onChange={this.handleCurrencyChange}
                      value={promo.value}
                      type='%'
                      disabled={!active || isFreebie}
                    />
                  }
                  <HelpBlock>Can&apos;t be more than 100</HelpBlock>
                </FormGroup>
              )}
            </div>
            <div className='row'>
              <FormGroup
                controlId='startDate'
                validationState={startDateError ? 'error' : null}
                className='col-md-6'
              >
                <DatePicker
                  label='Start Date'
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  value={promo.startDate}
                  inputProps={{
                    disabled: !active,
                  }}
                  handleChange={this.handleStartDateChange}
                />
              </FormGroup>
              <FormGroup
                controlId='startTime'
                validationState={timeError ? 'error' : null}
                className='col-md-6'
              >
                <ControlLabel>Start Time(UTC)</ControlLabel>
                <TimePicker
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={this.handleStartTimeChange}
                  value={start}
                  notClear
                  disabled={
                    promo.startDate === undefined ||
                    promo.startDate === '' ||
                    !active
                  }
                />
              </FormGroup>
            </div>
            <div className='row'>
              <FormGroup
                controlId='endDate'
                validationState={endDateError ? 'error' : null}
                className='col-md-6'
              >
                <DatePicker
                  label='End Date'
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  value={promo.endDate}
                  inputProps={{
                    disabled: !active,
                  }}
                  handleChange={this.handleEndDateChange}
                />
              </FormGroup>
              <FormGroup
                controlId='endTime'
                validationState={timeError ? 'error' : null}
                className='col-md-6'
              >
                <ControlLabel>End Time(UTC)</ControlLabel>
                <TimePicker
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={this.handleEndTimeChange}
                  value={end}
                  notClear
                  disabled={
                    promo.startDate === undefined ||
                    promo.startDate === '' ||
                    !active
                  }
                />
              </FormGroup>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                type='button'
                className='btn btn-primary pull-right'
                disabled={!active}
                onClick={this.handleSubmit}
                style={{ marginRight: '10px', marginTop: '25px' }}
              >
                {buttonText}
              </button>
              {isNewPromo && (
                <button
                  type='button'
                  className='btn btn-def pull-right'
                  onClick={this.createAndAddElse}
                  style={{ marginRight: '15px', marginTop: '25px' }}
                >
                  Create and add another
                </button>
              )}
            </div>
          </Form>
        </div>
      </Fragment>
    );
  }
}
